export default __webpack_public_path__ + "static/get-benefit-43002aa0187db53ed9fd2df032423b44.webp";